import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M14.5 13c-.694 0-1.322.283-1.775.74L5.972 9.276C5.982 9.184 6 9.094 6 9c0-.094-.018-.184-.028-.276l6.753-4.465A2.5 2.5 0 1 0 12 2.5c0 .253.049.491.118.721L5.544 7.568A2.493 2.493 0 0 0 3.5 6.5a2.5 2.5 0 1 0 0 5c.847 0 1.592-.423 2.044-1.067l6.573 4.346A2.485 2.485 0 0 0 12 15.5a2.5 2.5 0 1 0 2.5-2.5zm0-11.8a1.301 1.301 0 0 1 0 2.6 1.301 1.301 0 0 1 0-2.6zm-11 9.1a1.301 1.301 0 0 1 0-2.6 1.301 1.301 0 0 1 0 2.6zm11 6.5a1.301 1.301 0 0 1 0-2.6 1.301 1.301 0 0 1 0 2.6z" />
  </svg>
);

export default SvgComponent;
